module.exports = __webpack_public_path__ + "static/media/zip.b1b59a7e.svg";